import keyMirror from 'keymirror';

export const AerialOverlays = keyMirror({
  preassignments: null,
  tableTimer: null,
});
